import React, { FC } from 'react'
import {
  Box,
  Center,
  Grid,
  Skeleton,
  Stack,
  theme,
} from '@lojinha/design-system'

export const Loading: FC = () => {
  return (
    <Center htmlAttrs={{ style: { width: '100%' } }}>
      <Box
        display="grid"
        py="x64"
        htmlAttrs={{
          style: { gridTemplateColumns: 'repeat(12, 1fr)' },
        }}
      >
        <Grid gridColumn="3/6">
          <Box height={['304px']} width={'100%'}>
            <Skeleton htmlAttrs={{ style: { borderRadius: theme.space.x4 } }} />
          </Box>
        </Grid>

        <Grid gridColumn="8/11" htmlAttrs={{ style: { height: '72px' } }}>
          <Stack layout="horizontal" margin="x8">
            <Skeleton htmlAttrs={{ style: { borderRadius: theme.space.x8 } }} />
            <Skeleton htmlAttrs={{ style: { borderRadius: theme.space.x8 } }} />
          </Stack>
        </Grid>
      </Box>
    </Center>
  )
}
